import ScrollTransition from './transitions/scroll-transition';
import FadeTransition from './transitions/fade-transition';
export default {
  fade: FadeTransition,
  scroll: ScrollTransition
};


//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/es/all-transitions.js
// module id = 1718
// module chunks = 0